import ri from "./trigger-condition.js";
export default class ni {
  constructor(t, i) {
    (this.Zu = t), (this.tf = i), (this.Zu = t), (this.tf = i);
  }
  Jl(t) {
    if (null == this.Zu) return !1;
    const i = ri.if(t[0], this.Zu);
    if (!i) return !1;
    let r = null == this.tf || 0 === this.tf.length;
    if (null != this.tf)
      for (let i = 0; i < this.tf.length; i++)
        if (this.tf[i] === t[1]) {
          r = !0;
          break;
        }
    return i && r;
  }
  static fromJson(t) {
    return new ni(t ? t.id : null, t ? t.buttons : null);
  }
  Y() {
    return this.Zu;
  }
}
